// utils/formatDate.js
export function formatDbDate(dateString) {
    try {
        if (!dateString) return "—";

        const date = new Date(dateString);
        if (isNaN(date)) return "—";

        const options = {
            year: "numeric",
            month: "short",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        };

        // Uses user's local timezone automatically
        return new Intl.DateTimeFormat("en-US", options).format(date);
    } catch (error) {
        console.error("Date formatting error:", error);
        return "—";
    }
}
export function formatDbDateWithoutTime(dateString) {
    try {
        if (!dateString) return "—";

        const date = new Date(dateString);
        if (isNaN(date)) return "—";

        const options = {
            year: "numeric",
            month: "short",
            day: "2-digit",
        };

        // Uses user's local timezone automatically
        return new Intl.DateTimeFormat("en-US", options).format(date);
    } catch (error) {
        console.error("Date formatting error:", error);
        return "—";
    }
}
